import Button from '~/components/button'

export default class LinkButton extends Button {
    _shouldFirePress(key) {
        return ['Enter'].includes(key);
    }
}



// WEBPACK FOOTER //
// ./makosh/assets/components/link-button.js